// static/js/chat.jsx

/*
  This JSX file defines the entry point for the Chat Interface of the web application.
  It utilizes React's client-side rendering approach to mount the ChatInterface component.

  Functionality:
  - The file listens for the DOMContentLoaded event to ensure the DOM is fully loaded before attempting to render.
  - It identifies the 'chat-root' element in the DOM to serve as the mounting point for the React component.
  - Utilizes React 18's createRoot API to enable concurrent features in React for more flexible rendering.
  - Renders the ChatInterface component, which is expected to handle all interactions and UI elements related to the chat functionality of the application.

  Dependencies:
  - React: Used for building the user interface with component-based architecture.
  - ReactDOM: Provides DOM-specific methods that can be used at the top level of a web app to enable efficient updates of the React components.

  Usage:
  - This script is meant to be included in pages where a chat interface is required, with a div element having an id of 'chat-root'.
  - Ensure that this script is loaded and executed after the associated HTML structure is defined in the document.
*/

import React from 'react';
import { createRoot } from 'react-dom/client';
import ChatInterface from './components/ChatInterface';

// Mount the React component when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('chat-root');
  if (container) {
    const root = createRoot(container);
    root.render(<ChatInterface />);
  }
});
